const rawMunicipalities = require('./municipalities.json')
const rawPostalCodes = require('./postalCodes.json')
const {rent} = require('./renttransactions')

let sourceArray: any[] = [];
rent.forEach((item: any) => {
  const sourceIndex = sourceArray.findIndex((sourceItem: any) => sourceItem.label === item.source);
  if (sourceIndex === -1) {
    sourceArray.push({value: item.source, label: item.source});
  }
})

export const municipalities = Object.keys(rawMunicipalities).map(
  (k: string) => ({
    value: rawMunicipalities[k],
    label: rawMunicipalities[k],
  }),
)

export const postalCodes = Object.keys(rawPostalCodes).map((k: string) => ({
  value: k,
  label: `${k} – ${rawPostalCodes[k]}`,
}))

export const owners = require('./ownersData.json')

export const sources = sourceArray



// WEBPACK FOOTER //
// ./src/hardCodedData/index.ts